import React from 'react'
import CustomAppBar from '../components/CustomAppBar'
import { Box, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import { useSelector } from 'react-redux';


function ResetPasswordDone() {

    const navigate = useNavigate();

    return (
        <AppContainer>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight, alignItems: 'center' }}>
                <Box sx={{marginTop: '50px', width: '100%'}}>
                    <TextContainer>
                        <Typography variant='h5' sx={{marginTop: '40px'}}>Reset Password Email Sent!</Typography>
                        <Typography variant='body2' sx={{marginTop: '15px'}}>If you have an account with us, please check the email you entered for a link to reset your password.</Typography>
                    </TextContainer>
                    <TextContainer customStyles={{marginTop: '40px'}}>
                        <PrimaryButton text={"Done"} customStyles={{width: '100%'}} onClick={() => {navigate(`/login`)}}/>
                    </TextContainer>
                </Box>
            </Box>
            </AppContainer>
    )
}

export default ResetPasswordDone